export const atLeastOnePropertyNotEmpty = (obj) => {
  for (const key in obj) {
    if (typeof obj[key] === 'object') {
      if (atLeastOnePropertyNotEmpty(obj[key])) {
        return true;
      }
    } else if (obj[key] !== '' && obj[key] !== null) {
      return true;
    }
  }
  return false;
}

export const allPropertiesFilled = (obj) => {
  for (const key in obj) {
    if (typeof obj[key] === 'object') {
      if (!allPropertiesFilled(obj[key])) {
        return false;
      }
    } else if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
      return false;
    }
  }
  return true;
}
